<template>
  <span
    v-if="props.column.row.cell === undefined"
  >{{ getValue() }}</span>
  <span
    v-else-if="typeof props.column.row.cell === 'function'"
  >{{ functionRenderer() }}</span>
  <template v-else>
    <component
      :is="props.column.row.cell"
      v-bind="props.column.row.meta"
      :get-value="getValue"
      :row="rowRenderer()"
      :cell="cellRenderer()"
      :column="props.column"
      @row-clicked="(e) => emit('row-clicked', e)"
    />
  </template>
</template>

<script setup>
import { defineProps, defineEmits, defineOptions } from 'vue';
import { get } from 'lodash';

defineOptions({
  name: 'BodyCell',
});

const props = defineProps({
  column: {
    type: Object,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits([
  'row-clicked',
]);

const getValue = () => get(props.data, props.column.row.field);

const functionRenderer = () => {
  return props.column.row.cell({ getValue });
};
const rowRenderer = () => {
  return {
    original: props.data,
  };
};
const cellRenderer = () => {
  return {
    getValue,
  };
};
</script>
